import React, { useState, useEffect } from 'react';

interface CollapsibleSectionProps {
    title: string;
    subtitle?: string;
    defaultOpen?: boolean;
    children: React.ReactNode;
    headerRight?: React.ReactNode;
}

const ChevronIcon: React.FC<{ isOpen: boolean }> = ({ isOpen }) => (
    <svg
        className={`w-4 h-4 text-gray-400 transition-transform duration-200 shrink-0 ${isOpen ? 'rotate-180' : ''}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
    >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
);

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
    title,
    subtitle,
    defaultOpen = true,
    children,
    headerRight
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    useEffect(() => {
        setIsOpen(defaultOpen);
    }, [defaultOpen]);

    return (
        <div className="collapsible-section border border-gray-200 bg-white overflow-hidden">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`w-full flex items-center justify-between gap-3 px-4 py-3.5 bg-${isOpen ? 'gray-50':'white'} hover:bg-gray-50 transition-colors text-left`}
            >
                <div className="flex items-center gap-2 min-w-0">
                    <span className="text-sm font-medium text-gray-900 truncate">{title}</span>
                    {subtitle && (
                        <span className="text-xs text-gray-500 font-normal">{subtitle}</span>
                    )}
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    {headerRight && (
                        <div className="text-sm text-gray-500" onClick={e => e.stopPropagation()}>
                            {headerRight}
                        </div>
                    )}
                    <ChevronIcon isOpen={isOpen} />
                </div>
            </button>
            
            {isOpen && (
                <div className="px-4 py-4 border-t border-gray-100">
                    {children}
                </div>
            )}
        </div>
    );
};

export default CollapsibleSection;
